<template>
    <span @click.prevent="handleClick">
        <slot
            :loadingClass="{ loading: isLoading }"
        ></slot>
    </span>
</template>

<script>
import LoadingComponentMixin from "@mixins/LoadingComponentMixin";

export default {
    mixins: [
        LoadingComponentMixin
    ],
    methods: {
        handleClick: function (event) {
            if(this.isLoading){
                return
            }
            this.$emit('click', this)
        }
    }
}
</script>
